import React from "react";
import { ETAPA_LABELS, getEtapaAtual } from "../../utils/toc/etapas";
import { F } from "../../utils/gerencialFields";
import { toDisplayText } from "../../utils/data";
import { formatPct } from "./helpers";
import {
  CriticoIdent,
  CriticoMetrica,
  CriticoRow,
  CriticoZona,
  CriticosEmpty,
  CriticosList as CriticosListShell,
  CriticosSection,
  SectionHeader,
  SectionTitle,
} from "./styles";

const ZONA_LABELS = {
  preto: "Preto",
  vermelho: "Vermelho",
  amarelo: "Amarelo",
  verde: "Verde",
};

const ZONA_TONES = {
  preto: "danger",
  vermelho: "danger",
  amarelo: "warning",
  verde: "success",
};

function diasRestantes(status) {
  if (!status || status.pulmaoTotal == null || status.consumido == null) return null;
  const rest = Math.round(status.pulmaoTotal - status.consumido);
  return Number.isFinite(rest) ? rest : null;
}

export default function CriticosList({ criticos, onSelect, listRef }) {
  const top5 = (criticos || []).slice(0, 5);

  return (
    <CriticosSection ref={listRef}>
      <SectionHeader>
        <SectionTitle style={{ margin: 0 }}>Top 5 ambientes críticos</SectionTitle>
      </SectionHeader>
      {top5.length === 0 ? (
        <CriticosEmpty>
          Nenhum ambiente em zona crítica no momento — todos os pulmões em verde.
        </CriticosEmpty>
      ) : (
        <CriticosListShell>
          {top5.map(({ amb, status }) => {
            const etapa = getEtapaAtual(amb);
            const tone = ZONA_TONES[status.zona] || "default";
            const cliente = toDisplayText(amb[F.NOME_DO_CLIENTE], "Cliente não informado");
            const ambiente = toDisplayText(amb[F.AMBIENTE], "Ambiente não informado");
            const dias = diasRestantes(status);
            return (
              <CriticoRow
                key={`${cliente}-${ambiente}-${amb[F.NUMERO_DO_LOTE] || ""}`}
                type="button"
                onClick={() => onSelect?.({ amb, status, etapa })}
              >
                <CriticoZona $tone={tone}>{ZONA_LABELS[status.zona] || "—"}</CriticoZona>
                <CriticoIdent>
                  <strong>{cliente}</strong>
                  <span>
                    {ambiente}
                    {etapa ? ` · ${ETAPA_LABELS[etapa]}` : ""}
                  </span>
                </CriticoIdent>
                <CriticoMetrica>
                  <strong>{formatPct(status.pctConsumido)}</strong>
                  <span>
                    {dias != null
                      ? dias > 0
                        ? `${dias} du restantes`
                        : `${-dias} du estourado`
                      : "sem prazo"}
                  </span>
                </CriticoMetrica>
              </CriticoRow>
            );
          })}
        </CriticosListShell>
      )}
    </CriticosSection>
  );
}
